import teacherBadge01 from '../assets/teacher_badge01.png';
import teacherBadge03 from '../assets/teacher_badge03.png';
import teacherBadge04 from '../assets/teacher_badge04.png';
import teacherBadge05 from '../assets/teacher_badge05.png';
import teacherBadge06 from '../assets/teacher_badge06.png';

export const teacherBadgeList: Record<string, string> = {
  알리: teacherBadge01,
  티티: teacherBadge03,
  보보: teacherBadge04,
  하루: teacherBadge05,
  파피: teacherBadge06 
};
